<script setup>
import { defineComponent, h } from 'vue'
import { useLocalizedPath } from "@/use/useLocalizedPath";

const { getLocalizedPath } = useLocalizedPath();

const navigation = {
    social: [
    {
      name: 'Telegram',
      href: 'https://t.me/tps_rasmiy',
      icon: defineComponent({
        render: () =>
          h('svg', { fill: 'none', stroke: "currentColor", 'stroke-width': "1.5", strokeLinecap: "round", strokeLinejoin: "round", viewBox: '0 0 24 24' }, [
            h('path', {
              d: 'M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4'
            }),
          ]),
      }),
    },
  ],
}
</script>

<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-telegram" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" /></svg>


<template>
  <footer class="border-t border-gray-300" aria-labelledby="footer-heading">
    <h2 id="footer-heading" class="sr-only">Footer</h2>
    <div class="mx-auto max-w-7xl px-6 py-4 lg:py-8 lg:px-8">
      <div class="md:grid md:grid-cols-3 md:gap-4">
        <div class="md:space-y-8">
          <RouterLink :to="getLocalizedPath('/')">
            <img class="w-20" src="@/assets/images/logo-tps.svg" alt="Company name" />
          </RouterLink>
        </div>
        <div class="mt-5 grid grid-cols-1 gap-8 md:col-span-2 md:mt-0">
          <div class="md:grid md:grid-cols-1 md:gap-8">
            <div class="flex space-x-6">
              <a 
                v-for="item in navigation.social" 
                :key="item.name" 
                :href="item.href" 
                class="flex gap-2 text-black hover:text-black/50"
                target="_blank"
              >
                <span class="">{{$t('official_tps_channel')}}</span>
                <component :is="item.icon" class="h-6 w-6" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>
        <div class="mt-5 md:mt-0">
          <p class="text-xs leading-5 text-black/75">
            {{ $t('footer_copy_1', { copy: '&copy;', year: new Date().getFullYear() }) }}
            <br>
            {{ $t('footer_copy_2') }}
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>